import React, { Component } from 'react';
import Table from './common/table';

const $ = require('jquery');
$.DataTable = require('datatables.net');

class AdminTable extends Component {
  columns = [
    {
      path: 'phoneNumber',
      label: 'phoneNumber',
      content: (user) => user.phoneNumber,
    },
    {
      key: (user) => user._id,
      label: 'Full Name',
      content: (user) => `${user.name}`,
    },
    { path: 'email', label: 'Email' },
    { path: 'balance', label: 'Balance' },
  ];

  componentDidMount() {
    $(document).ready(function () {
      $('#dataTable').DataTable();
    });
  }

  render() {
    const { users, message } = this.props;
    return <Table columns={this.columns} data={users} message={message} />;
  }
}

export default AdminTable;
